import * as angular from 'angular';

class StorageLocationDetailsIdentifierCtrl implements ng.IController {
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public isEditable = this.isCreateMode || this.isEditMode;
    public identifierExpanded: boolean = true;

    constructor() {}

    $onInit() {}
}

angular.module('app').component('pkpStorageLocationDetailsIdentifier', {
    controller: StorageLocationDetailsIdentifierCtrl,
    template:
        require('app/storage-location/storage-location-details-identifier.component.html'),
    bindings: {
        form: '<',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
